import { techTheme, theme } from 'src/features/common/app/components/theme-provider/theme';
import styled from 'styled-components';
import { ITextInput } from './text-input.types';

const STATE_COLORS = {
    success: theme.colors.gs200,
    error: theme.colors.red400,
};
type StateType = keyof typeof STATE_COLORS;

export const StyledHelpMessage = styled.span<{ state: StateType }>`
    display: block;
    color: ${({ theme, state }) => (state ? STATE_COLORS[state] : theme.colors.gs200)};
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
`;

export const StyledInput = styled.input<ITextInput>`
    height: ${({ changeHeight }) => (changeHeight ? '32px' : '48px')};
    font-family: ${({ theme }) => theme.fonts.text};
    font-weight: 400;
    font-size: 16px;
    padding: 12px 12px 12px 16px;
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.grey800};
    border: ${({ state }) =>
        state ? `1px solid ${techTheme.colors.red400}` : `1px solid ${techTheme.colors.grey800}`};
    width: ${({ stretch }) => (stretch ? '100%' : '')};
    border-radius: 8px;

    &:disabled {
        border-color: ${techTheme.colors.gs450};
        color: ${techTheme.colors.grey400};
    }

    ::-webkit-input-placeholder {
        color: ${({ theme }) => theme.colors.gs100};
    }

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button,
    &[type='number'] {
        -webkit-appearance: none;
        margin: 0;
    }

    :autofill {
        -webkit-text-fill-color: ${({ theme }) => theme.colors.gs100};
        -webkit-box-shadow: 0 0 0 40rem ${({ theme }) => theme.colors.grey800} inset;
        -webkit-border-radius: 8px;
    }

    &:hover {
        border-color: ${techTheme.colors.gs450};
    }

    &:focus {
        outline: none;
        border: 1px solid ${techTheme.colors.gs450};
        background: ${({ theme }) => theme.colors.grey900};
    }

    &::placeholder {
        color: ${techTheme.colors.gs100};
    }
`;